<template>
  <menu-config :config-data="configData" :menu-configs="menuSetting" :configs="props"></menu-config>
</template>
<script>
import menuConfig from '@/materials/navMenu/render/customSubMenus/setting/menu-config.vue'
import { props, menuSetting } from './props'
export default {
  components: {
    menuConfig
  },
  props: {
    configData: undefined
  },
  created() {
    this.props = props
    this.menuSetting = menuSetting
  }
}
</script>

